import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { CSSProperties, FC } from 'react';
import {
  WbEntityRefLinks,
  WbEntityRefLinksProps,
} from '../../WbEntityRefLink/WbEntityRefLink';

type WbEntityRefLinksCellAdapterProps = {
  className?: string;
  style?: CSSProperties;
};

const useStyles = makeStyles(
  () => ({
    root: {
      display: 'block',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      width: '100%',
      // makes the span inside EntityDisplayName for truncation to take effect
      '& > *': {
        display: 'inline',
      },
    },
  }),
  { name: 'WbEntityRefLinkTableCell' },
);

export const WbEntityRefLinksCellAdapter: FC<
  WbEntityRefLinksCellAdapterProps & WbEntityRefLinksProps
> = ({ className, ...props }) => {
  const classes = useStyles();
  return (
    <WbEntityRefLinks {...props} className={clsx(classes.root, className)} />
  );
};
